import { Injectable } from '@angular/core';
import {UrlQueryService} from '../../../../common/url-query/url-query.service';
import {OfflineNetworkApiService} from '../network/offline-network-api.service';
import {HttpClient} from '@angular/common/http';
import {map} from 'rxjs/operators';
import {MetaDataService} from '../../../../metaData/meta-data.service';
import {NodeFilterService} from '../../../../../network/utils/filters/nodes/node-filter.service';

@Injectable({
  providedIn: 'root'
})
export class OfflineNodeApiService {

  constructor(private http: HttpClient,
              private metaDataService: MetaDataService,
              private offlineNetworkApiService: OfflineNetworkApiService) {}


  readonly offlineNodeUrl = 'planning/node';

  public getNodesForMap(params: any = {}): Promise<any> {
    return this.offlineNetworkApiService.getOfflineMap().pipe(map((mapData: any) => {
      const nodes = OfflineNetworkApiService.objectToArray(mapData.nodes);

      return this.filterNodes(nodes, params);
    })).toPromise();
  }

  public getNodeForMap(id: number): Promise<any> {
    return this.offlineNetworkApiService.getOfflineMap().pipe(map(mapData => {
      return mapData.nodes[id];
    })).toPromise();
  }

  public getNode(id: number): Promise<any> {
    return this.http.get(`${this.offlineNodeUrl}/${id}`).toPromise();
  }

  public getNodes(params: any = {}): Promise<any> {
    const url = UrlQueryService.addQueryParameters(this.offlineNodeUrl, {filter: params});
    return this.http.get(url).toPromise();
  }

  public moveNodes(nodes): Promise<any> {
    const url = `${this.offlineNodeUrl}/location`;
    return this.http.put(url, nodes).toPromise();
  }

  public exportNodeToTopology(id: number): Promise<any> {
    const url = `${this.offlineNodeUrl}/${id}/export`;
    return this.http.post(url, {}).toPromise();
  }

  public addNode(node): Promise<any> {
    return this.http.post(this.offlineNodeUrl, node).toPromise();
  }

  public editNode(node: any, id: number): Promise<any> {
    const url = `${this.offlineNodeUrl}/${id}`;
    return this.http.put(url, node).toPromise();
  }

  public lockNode(id: number): Promise<any> {
    const url = `${this.offlineNodeUrl}/${id}/lock`;
    return this.http.put(url, {lock: 1}).toPromise();
  }

  public unlockNode(id: number): Promise<any> {
    const url = `${this.offlineNodeUrl}/${id}/lock`;
    return this.http.put(url, {lock: 0}).toPromise();
  }

  public deleteNode(id): Promise<any> {
    const url = `${this.offlineNodeUrl}/${id}`;
    return this.http.delete(url).toPromise();
  }

  public lockNodes(ids): Promise<any> {
    const uri = `${this.offlineNodeUrl}/lock`;
    const url = UrlQueryService.addQueryParameters(uri, {filter: {id: {value: ids, operator: '='}}});

    return this.http.put(url, {lock: this.metaDataService.PeerConnectionAdminStatus.LOCKED.value}).toPromise();
  }

  public unlockNodes(ids): Promise<any> {
    const uri = `${this.offlineNodeUrl}/lock`;
    const url = UrlQueryService.addQueryParameters(uri, {filter: {id: {value: ids, operator: '='}}});

    return this.http.put(url, {lock: this.metaDataService.PeerConnectionAdminStatus.UNLOCKED.value}).toPromise();
  }

  public importNodeFromTopology(id: number): Promise<any> {
    const url = `${this.offlineNodeUrl}/${id}/import`;
    return this.http.post(url, {}).toPromise();
  }

  public importNodesFromTopology(nodeIds): Promise<any> {
    const uri = `${this.offlineNodeUrl}/import`;
    const filter = {id: {value: nodeIds, operator: '='}};
    const url = UrlQueryService.addQueryParameters(uri, {filter});
    return this.http.post(url, {}).toPromise();
  }

  private filterNodes(nodes, params): Promise<any> {
    return (params && params.mapFilter) ?
      NodeFilterService.mapFilter(nodes, params.searchObject) : nodes;
  }
}
